import { Separator } from '@mc/design-system'
import { useFreeTrial } from '@mc/free-trial'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import EmailSignup from 'components/EmailSignup'

const SharedRecipeEmailCapture = () => {
  const { trial } = useFreeTrial()
  const { t } = useTranslation('@mc/next')

  return (
    <section className='container mc-pb-9 mc-bg-light mc-theme-light'>
      <Separator className='mc-mt-0 mc-mb-10 col-12 mc-p-0' />
      <div className='row mc-text--center flex justify-content-center '>
        <div className='col-12 col-md-9 col-lg-6'>
          <p>{t('article.sharedRecipeEmailCapture.subtitle')}</p>
          <h2 className='mc-text-d1 mc-text--brand mc-text--uppercase mc-mt-4 mc-mb-8'>
            {trial.eligible
              ? t('article.sharedRecipeEmailCapture.title2', {
                  duration: trial.strings.durationShort,
                })
              : t('article.sharedRecipeEmailCapture.title', {
                  instructors: getNumberOfInstructors(),
                })}
          </h2>
          <EmailSignup showPricing={false} />
        </div>
      </div>
    </section>
  )
}

export default SharedRecipeEmailCapture
